import { AxiosInstance } from 'axios';
import ShiftTeamRepositoryInterface, { ApiCreateShiftTeamInterface, ShiftTeamInterface } from '@/services/Calendar/ShiftTeam/Interfaces';

export default class ShiftTeamRepository implements ShiftTeamRepositoryInterface {
  private apiPrefix = '/calendar/shifts/team';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllShiftTeams(departmentId: string, date: Date): Promise<ShiftTeamInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}?departmentId=${departmentId}&date=${date.toISOString().substr(0, 10)}`);

    return res.data;
  }

  public async getShiftTeamByShiftLeader(
    departmentId: string,
    shiftLeaderId: string,
    date: Date,
  ): Promise<ShiftTeamInterface> {
    const res = await this.axios.get(`${this.apiPrefix}/${departmentId}/${shiftLeaderId}/${date.toISOString().substr(0, 10)}`);

    return res.data;
  }

  public async createShiftTeam(data: ApiCreateShiftTeamInterface): Promise<boolean> {
    const res = await this.axios.post(this.apiPrefix, data);

    return res.status === 201;
  }

  public async deleteShiftTeam(id: number): Promise<void> {
    await this.axios.delete(`${this.apiPrefix}/${id}`);
  }

  public async getUserShiftStatistics(userId: string, date: Date): Promise<void> {
    await this.axios.get(`/shift-statistics?userId=${userId}&date=${date.toISOString().substr(0, 10)}`);
  }
}
